import { ReactNode } from 'react'

import Image from 'next/image'

import { atomMeditating } from '@ui/assets'
import { Container } from '@ui/components/Container'
import { StoreRatingsPill } from '@ui/components/StoreRatingsPill'

export const HeroCashRewardsLodge = ({
  className,
  title,
  description,
  form,
}: {
  className?: string
  title: ReactNode
  description: ReactNode
  form: ReactNode
}) => {
  return (
    <div className={className}>
      <div className="mb-6 flex items-center justify-center">
        <StoreRatingsPill />
      </div>
      <Container>
        <div>
          {/* Title */}
          <div className="flex flex-col items-center justify-center gap-5 pt-2 text-center md:pt-4 xl:pt-6">
            <h1 className="font-display text-3xl leading-tight tracking-tight text-[#0a2d4a] md:text-5xl lg:text-6xl">
              {title}
            </h1>
            <p className="h4 font-sans text-xl text-[#0a2d4a]/80">
              {description}
            </p>
          </div>
          {/* Image and Login */}
          <div className="mx-auto my-6 flex flex-col justify-between gap-5 lg:my-12 lg:flex-row">
            <div className="relative order-2 flex h-[300px] w-full items-center justify-center md:h-[350px] lg:order-first lg:h-[490px] lg:w-1/2">
              <Image
                alt="ATM ant"
                src={atomMeditating}
                loading="eager"
                priority={true}
                className="absolute w-[1000px]"
              />
            </div>
            <div className="flex w-full items-center justify-center self-center justify-self-center lg:w-1/2">
              <div className="w-full self-center justify-self-center lg:max-w-lg">
                {form}
              </div>
            </div>
          </div>
        </div>
      </Container>
    </div>
  )
}
